import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import type { AnyRoute } from "@tanstack/react-router";

export const createCoreRoutes = (parent: AnyRoute) => [
  createRoute({
    getParentRoute: () => parent,
    path: "/core/location",
    component: lazyRouteComponent(() => import("pages/core/location")),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/core/trip",
    component: lazyRouteComponent(() => import("pages/core/trip")),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/core/key_registration",
    component: lazyRouteComponent(() => import("pages/core/key_registration")),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/core/model",
    component: lazyRouteComponent(() => import("pages/core/model")),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/core/machine",
    component: lazyRouteComponent(() => import("pages/core/machine")),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/core/machine/$id",
    component: lazyRouteComponent(() => import("pages/core/machine/id")),
  }),
];
